export default __webpack_public_path__ + "e0f8da68c7d266e91faa05d87629c5eb.png";